// extracted by mini-css-extract-plugin
export default {"time_counter":"TimeCounter_time_counter__2fqz5","counter_case":"TimeCounter_counter_case__3xsTp"};